import React, {useContext} from 'react'
import {Form, InputNumber} from "antd";
import {PurchaseContext} from "../../../context/PurchaseContext";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const PurchaseDiscount = ({rowIndex}) => {
    const {purchaseItems} = useContext(PurchaseContext)
    const [purchaseList, setPurchaseList] = purchaseItems


    const handleDiscountChange = ({target: {value}}) => {
        const newList = replaceIndexAt(
            purchaseList,
            {
                ...purchaseList[rowIndex],
                discount: value
            },
            rowIndex
        )
        setPurchaseList(newList)
    }

    return(
        <React.Fragment>
            <Form>
                <Form.Item
                    style={{marginBottom: 0}}
                    name={'discount'}
                >
                    <InputNumber min={0} onBlur={handleDiscountChange} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default PurchaseDiscount